import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "autocomplete-cidade" }
const _hoisted_2 = ["value", "placeholder"]
const _hoisted_3 = {
  key: 0,
  class: "suggestions-list"
}
const _hoisted_4 = ["onMousedown", "onMouseenter"]
const _hoisted_5 = { class: "city-uf" }

import { ref, computed, watch, reactive, onMounted } from 'vue';
import * as cidadeService from '@/services/cidadesService';

interface Props {
  modelValue?: number
  placeholder?: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AutoCompleteCidade',
  props: {
    modelValue: {},
    placeholder: { default: 'Digite o nome da cidade' }
  },
  emits: ['update:modelValue', 'selected'],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const query = ref("")
const showSuggestions = ref(false)
const highlightedIndex = ref(-1)
const selectedCity = ref<cidadeService.Cidade | null>(null)

var controle = reactive({
  cidades: [] as cidadeService.Cidade[],
  text: "",
  status: ""
})

onMounted(() => {
  buscarCidades()
})

const filteredCities = computed(() => {
  const q = String(query.value).trim().toLowerCase()
  if (!q) return []

  return controle.cidades.filter(city =>
    city.nome.toLowerCase().includes(q) ||
    city.estado.toLowerCase().includes(q)
  )
})

// Computed para exibir o texto no input
const displayText = computed(() => {
  if (selectedCity.value) {
    return `${selectedCity.value.nome} - ${selectedCity.value.estado}`
  }
  return query.value
})

function onInput() {
  // Limpar cidade selecionada quando o usuário digitar
  if (selectedCity.value) {
    selectedCity.value = null
    emit('update:modelValue', undefined)
  }

  showSuggestions.value = true
  highlightedIndex.value = -1
}

function selectCity(city: cidadeService.Cidade) {
  selectedCity.value = city
  query.value = "" // Limpar query para não interferir no displayText
  showSuggestions.value = false
  highlightedIndex.value = -1

  emit('update:modelValue', city.cidadeId)
  emit('selected', city)
}

function hideSuggestions() {
  // Delay to allow click event on suggestion
  setTimeout(() => {
    showSuggestions.value = false
    highlightedIndex.value = -1
  }, 150)
}

function handleKeyDown(event: KeyboardEvent) {
  if (!showSuggestions.value || !filteredCities.value.length) return

  switch (event.key) {
    case 'ArrowDown':
      event.preventDefault()
      highlightedIndex.value = Math.min(
        highlightedIndex.value + 1,
        filteredCities.value.length - 1
      )
      break

    case 'ArrowUp':
      event.preventDefault()
      highlightedIndex.value = Math.max(highlightedIndex.value - 1, 0)
      break

    case 'Enter':
      event.preventDefault()
      if (highlightedIndex.value >= 0 && highlightedIndex.value < filteredCities.value.length) {
        selectCity(filteredCities.value[highlightedIndex.value])
      }
      break

    case 'Escape':
      event.preventDefault()
      showSuggestions.value = false
      highlightedIndex.value = -1
      break
  }
}

// Watch para sincronizar com modelValue externo
watch(() => props.modelValue, (newValue) => {
  if (newValue && controle.cidades.length > 0) {
    // Buscar a cidade pelo ID
    const cidade = controle.cidades.find(c => c.cidadeId === newValue)
    if (cidade) {
      selectedCity.value = cidade
      query.value = ""
    }
  } else if (!newValue) {
    selectedCity.value = null
    query.value = ""
  }
})

// Watch para buscar cidade quando o modelValue muda e ainda não temos as cidades
watch(() => controle.cidades, (cidades) => {
  if (props.modelValue && cidades.length > 0) {
    const cidade = cidades.find(c => c.cidadeId === props.modelValue)
    if (cidade) {
      selectedCity.value = cidade
      query.value = ""
    }
  }
})

// Reset highlighted index when filtered cities change
watch(filteredCities, () => {
  highlightedIndex.value = -1
})

function buscarCidades() {
  controle.status = "Buscando cidades...";

  cidadeService.obter({ tamanhoPagina: 6000 }).then(response => {
    controle.cidades = response;
    controle.status = "";
  }).catch(error => {
    console.error("Erro ao buscar cidades:", error);
    controle.status = `Erro ${error.message}`;
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("input", {
      type: "text",
      value: displayText.value,
      onInput: _cache[0] || (_cache[0] = (e) => { query.value = (e.target as HTMLInputElement).value; onInput(); }),
      onFocus: _cache[1] || (_cache[1] = ($event: any) => (showSuggestions.value = true)),
      onBlur: hideSuggestions,
      onKeydown: handleKeyDown,
      placeholder: __props.placeholder,
      class: "autocomplete-input form-control form-control-sm"
    }, null, 40, _hoisted_2),
    (showSuggestions.value && filteredCities.value.length)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredCities.value, (city, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: city.cidadeId,
              onMousedown: _withModifiers(($event: any) => (selectCity(city)), ["prevent"]),
              onMouseenter: ($event: any) => (highlightedIndex.value = index),
              class: _normalizeClass({
          'suggestion-item': true,
          'highlighted': index === highlightedIndex.value
        })
            }, [
              _createElementVNode("strong", null, _toDisplayString(city.nome), 1),
              _createElementVNode("span", _hoisted_5, " - " + _toDisplayString(city.estado), 1)
            ], 42, _hoisted_4))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})